import { gql } from '@apollo/client';

export const GET_PO_DATA = gql`
  query GetAllPOGiven {
    getAllPOGiven {
      orderid
      ApprovalDate
      updatedQuantity {
        title
        batchid
        Medium
        edition
        approvedquantity
        purchasePrice
      }
    }
  }
`;

export const GET_PO_DATA1 = gql`
  query GetAlPOGiven {
    getAlPOGiven {
      orderid
      ApprovalDate
      updatedQuantity {
        title
        batchid
        Medium
        edition
        approvedquantity
        purchasePrice
      }
    }
  }
`;

export const GET_CHALLAN = gql`
  query GetChallan {
    getChallan {
      selectedShipmentIds
    }
  }
`;


export const GET_ALL_RETURN_INBOUNDS = gql`
  query GetAllReturnInbounds {
    getAllReturnInbounds {
      grnNo
      count
      sku
      Title
    }
  }
`;

export const GET_RETURN_BY_GRN = gql`
  query GetReturnInboundByGRN($grnNo: Int!) {
    getReturnInboundByGRN(grnNo: $grnNo) {
      _id
      barcodeData
      grnNo
      date
      count
      sku
      Title
    }
  }
`;
